<template>
  <van-row class="line" type="flex">
    <van-col span="6">
      <div class="label">{{label}}:</div>
    </van-col>
    <van-col span="16">
      <div class="value">{{value}}</div>
    </van-col>
  </van-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String | Number,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  font-size: 28px;
  .label {
    color: #999;
  }
  .value {
    color: #666;
    font-size: 28px;
  }
}
</style>